<!--
	描述：星迅的svg图的遥控器弹窗
-->
<template>
    <dialogBody class="addDialogBody" @confirm="confirm" @cancel="cancel" :showCance="showCance" ref="body">
        <template slot="title">
            空调遥控参数设定
        </template>
        <div class="flexStart">
            <p>设定温度:</p>
            <input type="number" min="16" max="30" v-model="temperature">
            <span>℃</span>
        </div>
        <div class="flexStart">
            <p>开关机:</p>
            <label><input name="switchTypeRadio" type="radio" value="开机" v-model="switchType" @click="changeSwitch('开机')"/> 开机 </label>
            <label><input name="switchTypeRadio" type="radio" value="关机" v-model="switchType" @click="changeSwitch('关机')"/> 关机 </label>
        </div>
        <div class="flexStart">
            <p>运行模式:</p>
            <label><input name="runTypeRadio" type="radio" value="自动模式" v-model="runType" @click="changeRunType('自动模式')"/> 自动 </label>
            <label><input name="runTypeRadio" type="radio" value="制冷模式" v-model="runType" @click="changeRunType('制冷模式')"/> 制冷 </label>
            <label><input name="runTypeRadio" type="radio" value="制热模式" v-model="runType" @click="changeRunType('制热模式')"/> 制热 </label>
        </div>
        <div class="flexStart">
            <p>设定风速:</p>
            <label><input name="speedRadio" type="radio" value="自动" v-model="speed" @click="changeSpeed('自动')"/> 自动 </label>
            <label><input name="speedRadio" type="radio" value="低速" v-model="speed" @click="changeSpeed('低速')"/> 低速 </label>
            <label><input name="speedRadio" type="radio" value="中速" v-model="speed" @click="changeSpeed('中速')"/> 中速 </label>
            <label><input name="speedRadio" type="radio" value="高速" v-model="speed" @click="changeSpeed('高速')"/> 高速 </label>
        </div>
        <div class="flexStart">
            <p>扫风:</p>
            <label><input name="verticalRadio" type="radio" value="扫风关闭" v-model="vertical" @click="changeVertical('扫风关闭')"/> 关闭 </label>
            <label><input name="verticalRadio" type="radio" value="扫风开启" v-model="vertical" @click="changeVertical('扫风开启')"/> 打开 </label>
        </div>
    </dialogBody>
</template>

<script>
    import dialogBody from './dialogBody.vue'
    export default {
        components: {
            dialogBody
        },
        props: [],
        data() {
            return {
                temperature:23,
                runType: '',
                speed: '',
                vertical: '',
                switchType:'',
                callback: undefined,
                cancelCallBack: undefined,
                prop: [],
                group: undefined,
                operation: undefined,
                timeout: undefined,
                showCance: true
            }
        },
        computed: {},
        watch: {},
        mounted() {},
        methods: {
            changeVertical(nv) {
             if(nv == this.vertical) {
                 this.vertical = ''
             }
            },
            changeSpeed(nv) {
              if(nv == this.speed) {
                  this.speed = ''
              }
            },
            changeRunType(nv) {
                if(nv == this.runType) {
                    this.runType = ''
                }
            },
            changeSwitch(nv){
                if(nv == this.switchType) {
                    this.switchType = '';
                }
            },
            confirm() {
                let nameTypeList = []
                if (this.callback != undefined) {
                    if(!isempty(this.switchType)) {
                        nameTypeList.push("'"+this.switchType+"'")
                    }
                    if(!isempty(this.temperature)) {
                        nameTypeList.push("'"+this.temperature+'度'+"'")
                    }
                    if(!isempty(this.runType)) {
                        nameTypeList.push("'"+this.runType+"'")
                    }
                    if(!isempty(this.speed)) {
                        nameTypeList.push("'"+this.speed+"'")
                    }
                    if(!isempty(this.vertical)) {
                        nameTypeList.push("'"+this.vertical+"'")
                    }
                    let nameType =  nameTypeList.join(',')
                    this.callback(nameType)
                }else{
                    //默认执行的内容是调用接口
                    this.$api.webSocketApi.airConditionerOperation(this.group,this.operation,this.timeout,this.temperature,this.runType,this.speed,this.vertical,respon=>{
                        this.$dialogMethod.showMessage("下发成功!")
                    })
                }
                this.close()
            },
            cancel() {
                if (this.cancelCallBack != undefined) {
                    this.cancelCallBack()
                }
                this.close()
            },
            open(group,operation,timeout,prop, callback, cancelcallback, showCance) {
                this.group = group
                this.operation = operation
                this.timeout = timeout
                this.prop = prop
                this.callback = callback
                this.cancelCallBack = cancelcallback
                this.$refs.body.open()
                if (showCance != undefined) {
                    this.showCance = showCance
                }
                if (prop != undefined) {
                    //初始化
                    for (var i = 0, len = prop.length; i < len; i++) {
                        var item = prop[i]
                        switch (item.appType) {
                            case 280:
                                //设定温度
                                this.temperature = getValueIfNoNull(item.rtValue,23)
                                break
                            case 281:
                                //工作模式
                                this.runType = getValueIfNoNull(item.rtValue,0)
                                break
                            case 282:
                                //风速
                                this.speed = getValueIfNoNull(item.rtValue,0)
                                break
                            case 283:
                                //垂直风摆
                                this.vertical = getValueIfNoNull(item.rtValue,0)
                                break
                        }
                    }
                }
            },
            close() {
                this.$refs.body.hide()
            },
        }
    }
</script>
<style scoped>
    .addDialogBody {
        z-index: 200;
        display: flex;
        align-items: center;
        height: .4rem;
        justify-content: center;
    }

    .addDialogBody>input {
        border: .01rem solid #A9A9A9;
        border-radius: .05rem;
        margin-left: .2rem;
        padding: .02rem .05rem;
        line-height: .25rem;
        width: 2rem;
    }

    .flexStart {
        padding: 10px 0;
    }

    .flexStart label {
        margin-left: 10px;
    }
    .flexStart > p {
        width:60px;
        text-align: right;
    }
</style>
